import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-shared/components/page-error/src/assets/503.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')